import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./UserWelcomeScreen.css";

const UserWelcomeScreen = ({ setSelectedSection }) => {
  const username = localStorage.getItem("username") || "Guest";
  const location = useLocation();
  const navigate = useNavigate();

  const navigateToScreen = (screen) => {
    setSelectedSection(screen);
    navigate("/UserHome");
  };

  return (
    <div className="UWS-container">
      <div className="UWS-header">
        <div className="UWS-title-wrapper">
          <img
            className="UWS-home-icon"
            src={require("../images/home_icon.png")}
            alt="Home"
          />
          <h1 className="UWS-title">Hi {username}, Welcome Back</h1>
        </div>
        <p className="UWS-subtitle">
          Manage your care services, messages, and account details directly from
          your dashboard.
        </p>
      </div>

      <div className="UWS-grid">
        <div
          id="messages-button"
          className="UWS-card"
          onClick={() => navigateToScreen("Messages")}
        >
          <div className="UWS-icon-wrapper">
            <div className="UWS-count-badge">0</div>
          </div>
          <div className="UWS-card-info">
            <h3 className="UWS-card-title">Messages</h3>
            <p className="UWS-card-desc">0 new message</p>
          </div>
        </div>

        <div
          id="schedule-button"
          className="UWS-card"
          onClick={() => navigateToScreen("Calendar")}
        >
          <div className="UWS-icon-wrapper">
            <img src={require("../images/calendar_icon.png")} alt="Calendar" />
          </div>
          <div className="UWS-card-info">
            <h3 className="UWS-card-title">Schedule</h3>
            <p className="UWS-card-desc">Next Appointment</p>
            <p className="UWS-card-highlight">No Appointment</p>
          </div>
        </div>

        <div
          id="provider-button"
          className="UWS-card"
          onClick={() => navigateToScreen("Provider")}
        >
          <div className="UWS-icon-wrapper">
            <img src={require("../images/provider_icon.png")} alt="Providers" />
          </div>
          <div className="UWS-card-info">
            <h3 className="UWS-card-title">Care Providers</h3>
            <p className="UWS-card-desc">Browse available care staff</p>
            <p className="UWS-card-highlight">Click to view</p>
          </div>
        </div>

        <div id="invoices-button" className="UWS-card">
          <div className="UWS-icon-wrapper">
            <img src={require("../images/invoice_icon.png")} alt="Invoices" />
          </div>
          <div className="UWS-card-info">
            <h3 className="UWS-card-title">Invoices</h3>
            <p className="UWS-card-desc">Current Balance</p>
            <p className="UWS-card-highlight">$0.00</p>
          </div>
        </div>

        <div
          id="account-button"
          className="UWS-card"
          onClick={() => navigateToScreen("Account")}
        >
          <div className="UWS-icon-wrapper">
            <img src={require("../images/house_icon.png")} alt="Account" />
          </div>
          <div className="UWS-card-info">
            <h3 className="UWS-card-title">Account</h3>
            <p className="UWS-card-desc">Manage your profile details</p>
            <p className="UWS-card-highlight">Click to view</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserWelcomeScreen;
